import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Listens for 'auth:unauthorized' events dispatched by the HTTP client
 * and redirects to /login using React Router (preserving app state).
 */
export function useAuthRedirect() {
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => navigate('/login', { replace: true });
    window.addEventListener('auth:unauthorized', handler);
    return () => window.removeEventListener('auth:unauthorized', handler);
  }, [navigate]);
}
